import {AssistantContextSnapshot} from '@prompt-bridge/shared/ai-assistant-core';

/** Initial snapshot before any producer has run. Producers fill slices via patchContext. */
export const EMPTY_SNAPSHOT: AssistantContextSnapshot = {
  location: {path: '', query: {}, search: {}},
  language: '',
  recentErrors: [],
};
